import React, { FunctionComponent, useEffect, useState } from 'react';

import { Link, Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import './NewSidebarAVAP.css';
import './../NewDashboard.css';
import { Button, Col, Form, Modal, Row, Alert } from 'react-bootstrap';
import ObexRequestHandler from '../../../handlers/ObexRequestsHandler';
import BasicImgUser from '../../../assets/img/icono.png';
import BasicImgUserDark from '../../../assets/img/icono_dark.png';
import SessionService from '../../../services/SessionsService';
import SupportBanner from '../../../components/DashboardComponents/supportBanner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { UpdatedName } from '../../../redux/slices/updateSidebarGreen';
// import { updateName } from '../../../redux/slices/KnowDin';

const NewSidebarAVAP = () => {
  let { path, url } = useRouteMatch();

  const history = useHistory();
  const [get_personal_info, setGet_personal_info] = useState<any>({});
  const [showModalImg, setShowModalImg] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [disabledButtonSendImg, setDisabledButtonSendImg] = useState(false);
  const [errorMsg, setError] = useState('');

  const handleClose = () => setShowModalImg(false);
  const handleClose2 = () => setShowModal2(false);
  const [fileName, setFilename] = useState('Select File')

  const placeAvatar = 'data:image/png;base64,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'

  const isUpdatedName = useSelector((state: any) => state.updateSidebarGreen.name);
  const dispatch = useDispatch();
 
  const [showModal, setShowModal2] = useState(false);

    const [isDarkMode, setIsDarkMode] = useState(() => {
        const savedTheme = localStorage.getItem('theme');
        return savedTheme === 'dark';
    });

  const getPersonalInformation = async () => {
    try {
      // debugger
      const result = (await ObexRequestHandler.get('/get_personal_info')).data;
       console.log("sidebar", result);
      setGet_personal_info(result);
      // console.log(result.image);
      


    } catch (error) {
      console.error('ERROR FETCHING PERSONAL INFO ', error);
    }
  }

  const changeImg = () => {
    setShowModalImg(true)
    // console.log("changeImg");

  }

  

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
      console.log(file);
      setFilename(file.name);
    }
  };


  const handleSubmit = async() => {
    // Aquí puedes enviar la imagen al servidor o realizar otras acciones necesarias
      // Restablece el estado después de enviar la imagen
    if (selectedImage) {

      setDisabledButtonSendImg(true);

      const safedstring = selectedImage.toString(); 
      const base64SafedString = btoa(safedstring);

      const payload = { image: base64SafedString };
      
      try{
      const result = await ObexRequestHandler.post('/update_avatar', payload);
      
      // debugger
      if(result.success && result.success==true){
        setSelectedImage(null);
        setShowModalImg(false);
        setDisabledButtonSendImg(false);
        getPersonalInformation(); //re-render
      } else {
        setError('Image too big');
        setDisabledButtonSendImg(false)

        setTimeout(() => {
          setError('');
        }, 2000);


      }

    } catch {
      setError('Image too big');
      setDisabledButtonSendImg(false)
    }
      
    } else {
      console.log('No se ha seleccionado ningún archivo');
      setDisabledButtonSendImg(false)
    }
  };

  const decode_atob =(text)=>{
    const decodedText = atob(text);
    return decodedText;

  } 

  useEffect(() => {
    getPersonalInformation();

  }, [])

  useEffect(() => {
   

    if (isUpdatedName) {
      const timer = setTimeout(() => {
        getPersonalInformation();
        dispatch(UpdatedName(false));
      }, 1000);

      return () => clearTimeout(timer); // Limpia el timeout cuando el componente se desmonta o `isUpdatedName` cambia
    }
  }, [isUpdatedName, dispatch]);

  return (

    <div className='d-flex flex-column' style={{paddingLeft:'40px', paddingRight:'40px', backgroundColor:'var(--color-surface)', width:'100%'}}>
      <div className='marginTopProfile mb-3'>
        {get_personal_info && get_personal_info.image ?
          <div >
            <img className='sizeProfile' src={decode_atob(get_personal_info.image)} alt="" width={"100%"} height={"100%"} onClick={() => changeImg()} />
          </div> :
          <div className='sizeProfile border d-flex justify-content-center align-items-center'>
            <div>
            <FontAwesomeIcon
            icon={faPlusCircle}
            //className={loading ? `btn-comsumption-grey ml-1` :`btn-comsumption ml-1`}
            className='plusAvatar'/>
              <img id='AVATAR_ID' src={isDarkMode ? BasicImgUserDark:BasicImgUser} alt="" onClick={() => changeImg()} />
            </div>

          </div>
        }
      </div>
      <div id='id_owner' style={{ maxHeight:'80px', overflow:'hidden', wordWrap:'break-word', maxWidth:'180px' }} className='textBold colorBlack fontSizeProfile'>
        {get_personal_info && get_personal_info.first_name} {get_personal_info && get_personal_info.middle_name} {get_personal_info && get_personal_info.last_name}
      </div>
      <div className='colorGreen2 mb-4 fontSizeEmail'>
        {get_personal_info && get_personal_info.email}
      </div>



      <div className='d-flex flex-column colorBlack2'>

        <div  style={{ minWidth:'180px' }} className={`mb-3 ${location.pathname === `${url}/personal-information` ? 'active color-activo' : ''}`}>
          <Link to={`${url}/personal-information`} className={`fontSizeLinks ${location.pathname === `${url}/personal-information` ? 'color-activo' : ' colorBlack2 color-activo'}`}>Personal Information</Link>
        </div>

        <div  style={{minWidth:'180px'}} className={`mb-3 ${location.pathname === `${url}/sigin-and-security` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>
          <Link to={`${url}/sigin-and-security`} className={`fontSizeLinks ${location.pathname === `${url}/sigin-and-security` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>Sign-In and Security</Link>
        </div>

        <div  style={{minWidth:'180px'}} className={`mb-3 ${location.pathname === `${url}/licenses-and-suscriptions` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>
          <Link to={`${url}/licenses-and-suscriptions`} className={`fontSizeLinks ${location.pathname === `${url}/licenses-and-suscriptions` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>Licenses and Suscriptions</Link>
        </div>

        <div  style={{minWidth:'180px'}} className={`mb-3 ${location.pathname === `${url}/licenses-and-downloads` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>
          <Link to={`${url}/licenses-and-downloads`} className={`fontSizeLinks ${location.pathname === `${url}/licenses-and-downloads` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>Downloads</Link>
        </div>

        <div  style={{minWidth:'180px'}} className={`mb-3 ${location.pathname === `${url}/project-granted` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>
          <Link to={`${url}/project-granted`} className={`fontSizeLinks ${location.pathname === `${url}/project-granted` ? 'active color-activo' : ' colorBlack2 color-activo'}` }>API Projects Granted</Link>
        </div>
        <div  style={{minWidth:'180px'}} className={`mb-3 ${location.pathname === `${url}/licenses-manager` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>
          <Link to={`${url}/licenses-manager`} className={`fontSizeLinks ${location.pathname === `${url}/licenses-manager` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>Licenses Manager</Link>
        </div>
        <div  style={{minWidth:'180px'}} className={`mb-3 ${location.pathname === `${url}/payments` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>
          <Link to={`${url}/payments`} className={`fontSizeLinks ${location.pathname === `${url}/payments` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>Payment Methods</Link>
        </div>

        <div  style={{minWidth:'180px'}} className={`mb-3 ${location.pathname === `${url}/billing` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>
          <Link to={`${url}/billing`} className={`fontSizeLinks ${location.pathname === `${url}/billing` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>Billing</Link>
        </div>

        <div  style={{minWidth:'180px'}} className={`mb-3 ${location.pathname === `${url}/personal-information-tutorial` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>
          <div style={{cursor:'pointer'}} onClick={()=>{
            SessionService.TUTORIAL_SHOWED_ID= false; 
            if (window.location.pathname ==='/dashboard/personal-information') 
            {window.location.replace('/dashboard/personal-information');} 
            else 
            {
              history.push('/dashboard/personal-information')
              }
            }
            } className={`fontSizeLinks ${location.pathname === `${url}/personal-information-tutorial` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>Tutorial</div>
        </div>

        <div  style={{minWidth:'180px'}} className={`${location.pathname === `${url}/login` ? 'active' : ''}`}>
          <div style={{cursor:'pointer'}} onClick={()=>{setShowModal2(true)}} className="colorBlack2 fontSizeLinks">Sign out</div>
        </div>
        {/* <ul>
          <li>
            <Link to={`${url}/personal-information`}>Personal Information</Link>
          </li>
          <li>
            <Link to={`${url}/sigin-and-security`}>Sign-In and Security</Link>
          </li>
          <li>
            <Link to={`${url}/licenses-and-downloads`}>Licenses and Downloads</Link>
          </li>
          <li>
            <Link to={`${url}/project-granted`}>Project Granted</Link>
          </li>
          <li>
            <Link to={`${url}/payments-and-billing`}>Payments & Billing</Link>
          </li>
          <li>
            <Link to={`${url}/privacy`}>Privacy</Link>
          </li>
        </ul> */}

      </div>


      {/* MODAL BEGIN */}




      <Modal style={{ marginTop:'0rem', paddingTop:'7em' }} show={showModal} onHide={handleClose2} container={document.getElementById('avapIdWrapper')}>
        <Modal.Body className='colorBlack'>Do you want to sign out?</Modal.Body>
        <Modal.Footer>
          <button className="btn custom-button  textBold" onClick={() => history.push('/login')}>
            Yes
          </button>

          <button className="btn custom-button textBold" onClick={handleClose2}>
            No
          </button>
          
        </Modal.Footer>
      </Modal>



      
      <Modal style={{ marginTop:'0rem' }} show={showModalImg} onHide={handleClose} id="modalImg" dialogClassName="addons-dialog w-75 obex-dialog">
        <Modal.Header closeButton className="border-0 pb-0">
          <Col style={{ textAlign:'center' }}>
          <Modal.Title  className='fontSizeTitleCard textBold' style={{fontSize:'1.5rem', color:'black'}}>Select an image for your avatar</Modal.Title>
          </Col>
        </Modal.Header>
        <Modal.Body className=''>
          <Form >
            <Row>
              <Col style={{ marginLeft:'20px', marginRight:'20px', borderColor:'lightgray', borderStyle:'solid', borderWidth:'1px', borderRadius:'9px' }}>
            <Form.Group  controlId="formFile" className='m-0'>
              {/*<Form.Control className='btn  custom-button' style={{margin:'20px'}} type="file" accept=".jpg,.jpeg,.png" onChange=
              {handleFileChange} />*/}

              <label htmlFor="file-upload" className="btn custom-button textBold" style={{ margin:'20px' }}>
        Select a new Image
              </label>
    
        <input id="file-upload" type="file" accept='image/*' className='btn custom-button input-field ' hidden 
        onChange={ 
          handleFileChange
        }
         />      <span className='fontSizeTitleCard ' style={{ color:'black', position:'absolute', marginTop:'23px' }}>{fileName}</span>
              {/* Mostrar la vista previa de la imagen seleccionada */}
            </Form.Group>
            </Col>
            </Row>
              <div style={{maxHeight:'300px', overflow:'hidden'}} className='d-flex justify-content-center align-items-center'>
                <img src={selectedImage == undefined ? placeAvatar : selectedImage} alt="Preview" style={{ maxHeight:'300px', aspectRatio:'auto ', paddingTop:'20px', maxWidth: '30%', marginTop: '40px', marginBottom:'40px' }} />
              </div>
            
          </Form>
          { errorMsg!='' && <Alert variant='danger'>{errorMsg}</Alert> }
          
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex justify-content-center w-100'>
            <button className="btn custom-button textBold" onClick={handleSubmit} disabled={disabledButtonSendImg}>Save</button>

          </div>
        </Modal.Footer>
      </Modal>
      {/* MODAL END */}

    </div>
  )
}

export default NewSidebarAVAP;